<script>
	import { fade } from 'svelte/transition'
	import next from 'array-next'

	export let capabilities = []

	let activeCapability = capabilities[0]

	let height = 300

	let y

	let choicesEl

	let transitionHeight

	$: nextCapability = next(capabilities, activeCapability)

	function setHeight(node) {
		let cheight = node.clientHeight
		height = cheight
		if (!transitionHeight) {
			setTimeout(() => {
				transitionHeight = true
			}, 400)
		}
	}
</script>

<svelte:window bind:scrollY={y} />

<div class="capabilities">
	<div class="capability-selection" bind:this={choicesEl}>
		{#each capabilities as capability}
			<button
				class:active={capability === activeCapability}
				on:click={() => (activeCapability = capability)}>
				{capability.name}
			</button>
		{/each}
	</div>
	<div
		class="capability-content"
		style="padding-bottom: {height}px"
		class:transition-height={transitionHeight}>
		{#each capabilities as capability (capability.name)}
			{#if capability === activeCapability}
				<div class="cc-inner" transition:fade={{ duration: 200 }} use:setHeight>
					{#if capability.image}
						<div
							class="capability-image"
							style="background-image:url({capability.image.url});">
							<div
								style="padding-bottom:{(capability.image.height / capability.image.width) * 100}%" />
						</div>
					{/if}
					{@html capability.content}
						<button on:click={() => {
							y = choicesEl.offsetTop - 88
							activeCapability = nextCapability
						}}>Read about our {nextCapability.name}</button>
				</div>
			{/if}
		{/each}
	</div>
	<!-- <div class="capability-selection">
		{#each capabilities as capability}
			<button
				class:active={capability === activeCapability}
				on:click={() => (activeCapability = capability)}>
				{capability.name}
			</button>
		{/each}
	</div> -->
</div>
